<template>
  <div class="manual-container">
    <!-- Mobile Navigation Toggle -->
    <div class="lg:hidden mb-4">
      <button
        @click="showMobileNav = !showMobileNav"
        class="flex items-center w-full px-4 py-3 bg-white rounded-lg shadow-sm border border-gray-200 text-gray-700 font-medium"
      >
        <menu-icon class="w-5 h-5 mr-2" />
        <span>Navegación del Manual</span>
        <chevron-icon
          class="w-4 h-4 ml-auto transition-transform"
          :class="{ 'rotate-180': showMobileNav }"
        />
      </button>

      <!-- Mobile Nav Dropdown -->
      <transition name="slide">
        <div
          v-if="showMobileNav"
          class="mt-2 bg-white rounded-lg shadow-lg border border-gray-200 p-4"
        >
          <manual-nav @click="showMobileNav = false" />
        </div>
      </transition>
    </div>

    <div class="flex gap-8">
      <!-- Desktop Sidebar -->
      <aside class="hidden lg:block w-64 flex-shrink-0">
        <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-5">
          <manual-nav />
        </div>
      </aside>

      <!-- Main Content Area -->
      <main class="flex-1 min-w-0">
        <div class="bg-white rounded-xl shadow-sm border border-gray-200 p-6 lg:p-8">
          <router-view />
        </div>
      </main>
    </div>
  </div>
</template>

<script>
import ManualNav from "@/components/manual/ManualNav.vue";
import MenuIcon from "@/icons/MenuIcon.vue";
import ChevronIcon from "@/icons/ChevronIcon.vue";

export default {
  name: "ManualIndex",

  components: {
    ManualNav,
    MenuIcon,
    ChevronIcon,
  },

  data() {
    return {
      showMobileNav: false,
    };
  },

  watch: {
    $route() {
      this.showMobileNav = false;
    },
  },
};
</script>

<style scoped>
.manual-container {
  @apply w-full;
}

.slide-enter-active,
.slide-leave-active {
  transition: all 0.2s ease;
}

.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}
</style>
